module.exports = ol.events.condition;